import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles(() => ({
  cta: {
    flex: 1,
    minWidth: 0,
    fontSize: 12,
    color: grey[600],
    textAlign: "center",
    overflowWrap: "break-word",
    hyphens: "auto",
    background: "none",
    border: "none",
    padding: 0,
    font: "inherit",
    cursor: "pointer",
    outline: "inherit",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;
